<template>
    <div class="dialog" v-if="showDialog">
        <div class="dialog_mask"></div>

        <div class="dialog_container">
            <div class='container'>
                <div class='list'>
                    <div class='title'> 巡 检 人 员 轨 迹 展 示
                        <div class='close' @click='closeDialog'></div>
                    </div>
                    <div class="search">
                        <el-date-picker
                                v-model="start"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm"
                                placeholder="选择开始日期时间">
                        </el-date-picker>
                        <el-date-picker
                                v-model="end"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm"
                                placeholder="选择结束日期时间">
                        </el-date-picker>
                        <el-button type="primary" icon="el-icon-search" size="medium" @click="handle_search">搜索
                        </el-button>
                    </div>
                    <div class="maps">
                        <div class="amap_box" ref="amapBox"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dataUrl from '../../../libs/js/interfaceAddress.js'
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: 'xunjian_line.vue',
        props: {
            showDialog: {
                type: Boolean,
                default: false
            },
            positionData: {
                type: Array,
                default: () => []
            },
            userId: {
                type: [String, Number],
                default: () => ''
            }
        },
        data () {
            return {
                start: '',
                end: '',
                user_id: '',
                xunjian_position: [],
            }
        },
        components: {},
        mounted () {
            //获取巡检人员得id
            this.user_id = this.userId
            //页面初始化时处理
            this.$nextTick(() => {
                this.xunjian_position = this.positionData
                this.new_map()

            })

        },
        // computed: {
        //   ...mapState(['userId'])
        // },
        methods: {
            //关闭巡检轨迹弹出框
            closeDialog () {
                this.$emit('closeDialog')
            },
            /**
             * 获取巡检轨迹的数据
             * start 开始时间
             * end  结束时间
             *
             * */
            get_xunjian_data (start, end) {

                this.$http.post(dataUrl.interfaceAddress.getPos, {
                    userId: this.user_id,
                    start: start,
                    end: end,
                    // start: 1569718800,
                    // end: 1569726000,
                }).then(res => {
                    if (res.data && res.data.code === 1) {
                        var arr = []
                        if (res.data && res.data.code === 1) {
                            var position_data = res.data.data
                            for (let item in position_data) {
                                var position = (position_data[item].pos).split(',')
                                var obj = {
                                    lnglat: position,
                                    time: position_data[item].datetime,
                                }
                                arr.push(obj);
                            }
                            this.xunjian_position = [];
                            this.xunjian_position = arr;
                            if (position_data.length <= 0) {
                                this.$message({
                                    showClose: true,
                                    message: '该时间段未查询到巡检轨迹，请重新确认',
                                    type: 'warning'
                                })
                                this.new_map(this.xunjian_position);

                            } else {
                                this.new_map(this.xunjian_position);
                            }

                        }
                    }

                }).catch((err) => {
                    console.log(err)
                    // reject(err)
                })
            },
            /**
             * 验证开始时间是否大于结束时间
             * @param _startTime  开始时间
             * @param _endTime    结束时间
             * 说明：先判断选择是否为空，不为空的情况下先验证开始时间是否大于结束时间，满足条件再执行搜索获取数据
             * @returns {IterableIterator<boolean>}
             */
            check(_startTime,_endTime){
                var start = _startTime;
                var end = _endTime;
                var startTime=_startTime.substring(0,10);
                var endTime=_endTime.substring(0,10);
                if (start != '' || end != '') {
                    //验证日期
                    if(startTime.length>0 && endTime.length>0){
                        var startTmp=startTime.split("-");
                        var endTmp=endTime.split("-");
                        var sd=new Date(startTmp[0],startTmp[1],startTmp[2]);
                        var ed=new Date(endTmp[0],endTmp[1],endTmp[2]);
                        if(sd.getTime()>ed.getTime()){
                            this.$message({
                                showClose: true,
                                message: '开始日期不能大于结束日期',
                                type: 'warning'
                            })
                            return false;
                        } else {
                            var start_date = (new Date(start).getTime()) / 1000;
                            var end_date = (new Date(end).getTime()) / 1000;
                            this.get_xunjian_data(start_date, end_date);
                        }
                    }
                    return true;
                } else {
                    this.$message({
                        showClose: true,
                        message: '搜索时间不能为空，请选择时间段搜索',
                        type: 'warning'
                    })
                }
            },
            //搜索时间段巡检轨迹
            handle_search () {
                var start = '';
                var end = '';
                start=this.start;
                end=this.end;
                //验证开始时间是否大于结束时间
                this.check(start,end);



            },
            /**
            * 初始化地图
             * pointData  轨迹数据
             *
            * */
            new_map (pointData) {
                var point_data = pointData
                //简单数据附加
                var map = new AMap.Map(this.$refs.amapBox, {
                    zoom: 4,
                    mapStyle: 'amap://styles/0b430c027c7b96a310568a413e275738',
                })
                //如果无数据则不走下面逻辑
                if (this.xunjian_position.length <= 0) {
                    return
                }
                var defaultRenderOptions = {
                    renderAllPointsIfNumberBelow: -1,
                    pathTolerance: 2,
                    keyPointTolerance: 0,
                    pathLineStyle: {
                        lineWidth: 1,
                        strokeStyle: 'yellow',
                        borderWidth: 1,
                        borderStyle: '#eeeeee',
                        dirArrowStyle: false
                    },
                    pathLineHoverStyle: {
                        lineWidth: 3,
                        strokeStyle: 'rgba(204, 63, 88,1)',
                        borderWidth: 1,
                        borderStyle: '#cccccc',
                        dirArrowStyle: false
                    },
                    pathLineSelectedStyle: {
                        lineWidth: 6,
                        strokeStyle: '#C11534',
                        borderWidth: 1,
                        borderStyle: '#cccccc',
                        dirArrowStyle: true
                    },
                    dirArrowStyle: {
                        stepSpace: 35,
                        strokeStyle: '#ffffff',
                        lineWidth: 2
                    },
                    startPointStyle: {
                        radius: 4,
                        fillStyle: '#109618',
                        lineWidth: 1,
                        strokeStyle: '#eeeeee'
                    },
                    endPointStyle: {
                        radius: 4,
                        fillStyle: '#dc3912',
                        lineWidth: 1,
                        strokeStyle: '#eeeeee'
                    },
                    keyPointStyle: {
                        radius: 3,
                        fillStyle: 'rgba(8, 126, 196, 1)',
                        lineWidth: 1,
                        strokeStyle: '#eeeeee'
                    },
                    keyPointHoverStyle: {
                        radius: 4,
                        fillStyle: 'rgba(0, 0, 0, 0)',
                        lineWidth: 2,
                        strokeStyle: '#ffa500'
                    },
                    keyPointOnSelectedPathLineStyle: {
                        radius: 4,
                        fillStyle: 'rgba(8, 126, 196, 1)',
                        lineWidth: 2,
                        strokeStyle: '#eeeeee'
                    }
                }

                var _this = this
                AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function (PathSimplifier, $) {

                    if (!PathSimplifier.supportCanvas) {
                        alert('当前环境不支持 Canvas！')
                        return
                    }

                    var pathSimplifierIns = new PathSimplifier({
                        zIndex: 100,
                        //autoSetFitView:false,
                        map: map, //所属的地图实例

                        getPath: function (pathData, pathIndex) {
                            var points = pathData.points,
                                lnglatList = []

                            for (var i = 0, len = points.length; i < len; i++) {
                                lnglatList.push(points[i].lnglat)
                            }

                            return lnglatList
                        },
                        getHoverTitle: function (pathData, pathIndex, pointIndex) {

                            if (pointIndex >= 0) {
                                //point
                                return pathData.name + '：' + pathData.points[pointIndex].time
                            }

                            return pathData.name + '，点数量' + pathData.points.length
                        },
                        renderOptions: defaultRenderOptions,
                        // renderOptions: {
                        //
                        //     renderAllPointsIfNumberBelow: 100 //绘制路线节点，如不需要可设置为-1
                        // }
                    })

                    window.pathSimplifierIns = pathSimplifierIns

                    //设置数据
                    pathSimplifierIns.setData([
                        {
                            name: '巡检时间',
                            points: point_data,
                            // points: [{
                            //   lnglat: ['116.405289', '39.904987']
                            // }, {
                            //   lnglat: ['113.964458', '40.54664']
                            // }, {
                            //   lnglat: ['111.47836', '41.135964']
                            // }, {
                            //   lnglat: ['108.949297', '41.670904']
                            // }, {
                            //   lnglat: ['106.380111', '42.149509']
                            // }, {
                            //   lnglat: ['103.774185', '42.56996']
                            // }, {
                            //   lnglat: ['101.135432', '42.930601']
                            // }, {
                            //   lnglat: ['98.46826', '43.229964']
                            // }, {
                            //   lnglat: ['95.777529', '43.466798']
                            // }, {
                            //   lnglat: ['93.068486, 43.64009']
                            // }, {
                            //   lnglat: ['90.34669', '43.749086']
                            // }, {
                            //   lnglat: ['87.61792', '43.793308']
                            // }]
                        },
                    ])
                    //添加巡航器
                    var navg1 = pathSimplifierIns.createPathNavigator(0, {
                        loop: false, //循环播放
                        speed: 10000 //巡航速度，单位千米/小时
                    })

                    navg1.start()

                    //选中路线0
                    // pathSimplifierIns.setSelectedPathIndex(0);
                    //
                    // pathSimplifierIns.on('pointClick', function(e, info) {
                    //
                    //     console.log('Click: ' + info.pathData.points[info.pointIndex].name);
                    // });
                })

            },
        }
    }
</script>
<style lang="less" scoped>
    .dialog {
        position: relative;
        height: 300px;

        .dialog_mask {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.9);
            z-index: 10;
        }

        .container {
            width: 800px;
            height: 600px;
            position: fixed;
            top: 15%;
            left: 0px;
            right: 0px;
            margin-left: auto;
            margin-right: auto;
            z-index: 10;

            .close {
                width: 35px;
                height: 35px;
                cursor: pointer;
                margin-left: 95%;
                /*margin-bottom: 10px;*/
                // height: 20px;
                background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/close.png) no-repeat;
                background-size: 100% 100%;
                z-index: 10;
                position: absolute;
                bottom: 0px;

            }

            .list {
                width: 800px;
                height: 650px;
                background: red;
                background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/dialog_bg.png) no-repeat;
                background-position: 50% 50%;
                background-size: 100% 100%;

                .title {
                    height: 50px;
                    text-align: center;
                    font-size: 20px;
                    color: #ffffff;
                    line-height: 62px;
                    position: relative;
                }

                .search {
                    margin-top: 30px;
                    text-align: center;
                }

                .maps {
                    height: 484px;
                    background: skyblue;
                    border: 2px solid #0166a7;
                    margin: 15px 30px 20px 40px;

                    .amap_box {
                        width: 100%;
                        height: 480px;


                    }
                }

            }


        }
    }

</style>
<style>
    .el-input__inner {
        height: 36px;
    }
</style>



// WEBPACK FOOTER //
// src/page/main_content/xunjian/xunjian_line.vue